import { render, staticRenderFns } from "./ActivityTimeLineItemManageTargetsOnSource.vue?vue&type=template&id=52472548&"
import script from "./ActivityTimeLineItemManageTargetsOnSource.vue?vue&type=script&lang=ts&"
export * from "./ActivityTimeLineItemManageTargetsOnSource.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports